import styled from "styled-components";
import { FriendListBg } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	margin: 0;
	background-color: #ffffff;
	/* padding: 20px 16px; */
	/* .ant-table-wrapper {
    margin: 82px 16px 24px 16px;
  } */
`;

export const Heading = styled.div`
	display: flex;
	justify-content: center;
`;

export const TitleWrapper = styled.div`
	margin: 10px 0 5px;
	background-image: url(${FriendListBg});
	background-repeat: no-repeat;
	background-position: center; /* Center the background image horizontally and vertically */
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	width: 230px;
`;

export const Title = styled.p`
	color: #000000;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 50px;
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
`;

export const NoFriendWrapper = styled.div`
	background-color: #e1f0ff;
	height: 70vh;
	width: 93%;
	margin: 0 auto;
	border-radius: 10px !important;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	overflow-y: hidden;
`;

export const FriendListContiner = styled.div`
	& > div:first-child {
		border-radius: 10px 10px 0 0;
	}

	& > div:last-child {
		border-radius: 0 0 10px 10px;
	}
`;

export const OuterDiv = styled.div`
	background-color: #e1f0ff;
	&:not(:last-child) {
		border-bottom: 1px solid #66bfe9;
	}
	display: flex;
	justify-content: space-between;
	padding: 16px 0;
`;

export const InfoText = styled.span`
	color: ${(props) => (props.isName === true ? "#000000" : "#535353")};
	font-size: ${(props) => (props.isName === true ? "16px" : "14px")};
	line-height: 14px;
	font-weight: 400;
`;

export const FriendInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const Number = styled.div`
	width: 20px;
	font-size: 16px;
	font-weight: 400;
	color: #000000;
`;

export const LeftSection = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 12px;
`;

export const DateText = styled.div`
	color: #0095da;
	font-weight: 500;
	font-size: 16px;
`;

export const InviteText = styled.p`
	color: #000000;
	font-weight: 400;
	font-size: 14px;
`;
